module.exports = __webpack_public_path__ + "img/683.8b250615.gif";